import React from 'react';
import { Card } from './Card';

interface Props {
  /** Path/URL to an SVG illustration, or an inline React node */
  illustration?: string | React.ReactNode;
  /** Large icon fallback (used when no illustration provided) */
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  /** Extra padding / centering wrapper classes */
  className?: string;
}

export const EmptyState: React.FC<Props> = ({
  illustration,
  icon,
  title,
  description,
  action,
  className = '',
}) => (
  <Card padded={false} className={`overflow-hidden ${className}`}>
    <div className="flex flex-col items-center px-6 py-14 text-center">
      {/* Illustration */}
      {illustration && typeof illustration === 'string' ? (
        <img src={illustration} alt="" aria-hidden width={120} height={120} className="mb-2 opacity-90 select-none pointer-events-none" />
      ) : illustration ? (
        <div className="mb-2">{illustration}</div>
      ) : icon ? (
        // Icons on the gold tile are always white, whatever colour the caller gave them.
        <div className="mb-2 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary text-white shadow-soft [&_svg]:text-white!">
          {icon}
        </div>
      ) : null}

      <h3 className="mt-4 font-display text-[20px] font-bold tracking-tight text-text-primary">
        {title}
      </h3>
      {description && (
        <p className="mt-2 max-w-md text-[13.5px] leading-relaxed text-text-muted">
          {description}
        </p>
      )}
      {action && <div className="mt-6 flex flex-col gap-2 sm:flex-row">{action}</div>}
    </div>
  </Card>
);
